import { render, staticRenderFns } from "./VendorGeneralNotes.vue?vue&type=template&id=73290fd7&scoped=true&"
import script from "./VendorGeneralNotes.vue?vue&type=script&lang=js&"
export * from "./VendorGeneralNotes.vue?vue&type=script&lang=js&"
import style0 from "./VendorGeneralNotes.vue?vue&type=style&index=0&id=73290fd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73290fd7",
  null
  
)

export default component.exports